import { ClickAwayListener, IconButton, InputAdornment, Tooltip, makeStyles } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    fontSize: theme.typography.pxToRem(13),
    lineHeight: 1.5,
    maxWidth: 320,
  },
}));

const FieldWithTooltip = ({ tooltip, children }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const handleClose = () => setOpen(false);
  const handleToggle = () => setOpen((isOpen) => !isOpen);

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        {React.cloneElement(children, {
          InputProps: {
            ...children.props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip
                  open={open}
                  onClose={handleClose}
                  title={<FormattedMessage id={tooltip} />}
                  classes={{ tooltip: classes.tooltip }}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                >
                  <IconButton size="small" onClick={handleToggle}>
                    <HelpOutlineIcon fontSize="small" color="disabled" />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          },
        })}
      </div>
    </ClickAwayListener>
  );
};

export default FieldWithTooltip;
